import GetCurrentUrl from './types';

const getCurrentUrl: GetCurrentUrl = () => window.location.href;

export default getCurrentUrl;
